<template>
  <div id="Opportunities_ScholarshipPrograms">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>
    <usc-intro :copy="this.intro"></usc-intro>
    <div class="body mb gutter-lg">
      <h2>Renaissance and Discovery Scholars</h2>
      <p>USC&mdash;which offers more than 150 undergraduate majors and 150 minors that encompass the arts and humanities, the social and natural sciences and the professions—also offers two scholarship programs for high-achieving undergraduate students: the USC Renaissance Scholars program and the USC Discovery Scholars program. Undergraduates who pursue a major and minor (or two majors) in widely separated fields of study and maintain a minimum GPA are honored as USC Renaissance Scholars, while students who excel in the classroom and also produce exceptional scholarship or artistic works are encouraged to pursue the Discovery Scholar honor, which is offered within every major concentration at the University.</p>
    </div>
    <div class="body mb gutter-lg">
      <h2>Global Scholars</h2>
      <p>The Global Scholars program recognizes undergraduates who have excelled in their studies both at home and abroad. Every year, up to 10 Global Scholars receive a $10,000 prize to be applied toward graduate study. Students must have an overall USC GPA of 3.5 or higher to be considered for this distinction and must have participated in an international program administered by USC or an outside institution.</p>
      <p>Applicants must have spent a minimum of 10 weeks abroad in one or more academic, work-experience or service-learning programs as part of their undergraduate experience. For international students, the overseas experience must be outside their home country, preferably in a different region of the world.</p>
      <p>Global Scholars are expected to complete a capstone paper, project or research paper in which they reflect on their international experience. This project, for which each USC school has different criteria, is intended to validate the depth and quality of the student’s time abroad.</p>
    </div>
  </div>
</template>

<script>
import hero from '@/components/Hero'
import intro from '@/components/Intro'

export default {
  name: 'ScholarshipPrograms',
  components: {
    'usc-hero': hero,
    'usc-intro': intro
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Scholar Programs',
        loResSrc: './static/blur/Opportunities_ScholarPrograms.jpg',
        hiResSrc: './static/Opportunities_ScholarPrograms.jpg'
      },
      intro: [
        'USC’s scholar programs—including Discovery, Global and Renaissance Scholars—salute excellence in undergraduate education by recognizing students who have surpassed academic expectations. Interested USC students may apply for the respective scholars’ designations; recognized scholars receive a medallion to wear at graduation, have their designation noted on their final transcript from the University and may be eligible for a $10,000 prize toward graduate study or other approved post-graduate endeavors.'
      ]
    }
  },
  created () {
    this.$root.setPageHeader('Opportunities', 'Scholar Programs')
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/advantages/ScholarPrograms.vue